







import { Prop, Component, Vue } from 'vue-property-decorator'

@Component
export default class IconLicense extends Vue {
    @Prop({ type: Number, default: 50 }) readonly size!: number
}
